import { NavLink, Outlet } from "react-router";
import { useAuthStore } from "../stores/authStore";

const navItems = [
  { to: "/", label: "Dashboard", icon: "📊" },
  { to: "/users", label: "Users", icon: "👥" },
  { to: "/content", label: "Content", icon: "📚" },
  { to: "/analytics", label: "Analytics", icon: "📈" },
];

export function AdminLayout() {
  const signOut = useAuthStore((s) => s.signOut);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <aside className="flex w-56 shrink-0 flex-col border-r border-gray-200 bg-white">
        <div className="flex h-14 items-center gap-2 border-b px-4">
          <span className="text-xl">🦫</span>
          <span className="text-sm font-bold text-gray-900">BP Admin</span>
        </div>

        <nav className="flex-1 space-y-1 p-3">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                }`
              }
            >
              <span>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t p-3">
          <button
            onClick={signOut}
            className="w-full rounded-lg px-3 py-2 text-left text-sm text-gray-600 hover:bg-gray-100"
          >
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-6">
        <Outlet />
      </main>
    </div>
  );
}
